/**
 * The default page length for entity tables.
 */
export const DEFAULT_PAGE_LENGTH = 10;

export const ComboboxOptions = {
	Bools: [
		{ value: "yes", display: "Yes" },
		{ value: "no", display: "No" },
	]
}